/* Jubi Filter Offset — keeps the collection filter bar clear of the
   header in "dynamic" header mode.

   How the theme's dynamic header actually works (layout/theme.liquid):
   the <header x-ref="header"> is ALWAYS sticky at top:0 — the hidden
   state is opacity:0 + pointer-events:none, not removal. So its rect
   is always ~full height and can't be used alone (that mistake parked
   the filter bar 140px down the viewport permanently). The reliable
   hidden/visible signal is pointer-events: none — Alpine sets it
   exactly when the header is hidden. Offset = header bottom when
   interactive, 0 when not. */
(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('.collection-filter-sidebar');
    if (!bar) return;

    var header = document.querySelector('[x-ref="header"]') ||
                 document.querySelector('body > header');
    if (!header) return;

    /* ride the header's 300ms reveal animation */
    bar.style.transition = 'top 0.3s ease';

    var ticking = false;

    function offset() {
      var cs = window.getComputedStyle(header);
      if (cs.pointerEvents === 'none' || parseFloat(cs.opacity) < 0.05) return 0;
      var rect = header.getBoundingClientRect();
      return rect.bottom > 0 ? Math.round(rect.bottom) : 0;
    }

    function apply() {
      bar.style.top = offset() + 'px';
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(apply);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    /* the reveal finishes after scrolling stops — trail it */
    var trail;
    window.addEventListener('scroll', function () {
      clearTimeout(trail);
      trail = setTimeout(apply, 350);
    }, { passive: true });
    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
